
import { Component, Vue, Watch, PropSync } from "vue-property-decorator";
import { Distinta, RigaDistinta, StatoVariazioneRigaDistinta, VariazioneRigaDistinta,VariazioneDaComunicare, TipoVariazione, VariazioneDaComunicareQtaTaglia, RigaInValidazione } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';
import ValidazioniMassive from './ValidazioniMassive.vue';

@Component({
    components: {                
        ValidazioniMassive
    }
})
export default class RigaDistintaInValidazione extends Vue {
    
    @PropSync('rigaDistinta') private riga!: RigaInValidazione;

    @PropSync('variazione') private variazioneDiValidazione!: VariazioneRigaDistinta;

    private StatoVariazione = StatoVariazioneRigaDistinta;

    private backupVariazione : any = {};

    get variazioniDaProcessare(): VariazioneRigaDistinta[]
    {
        if(this.riga.variazioniComunicate) {
            let indiceAttivo = this.riga.indiceVariazioneAttiva || 0;
            return this.riga.variazioniComunicate.filter(x => x && x.indice > indiceAttivo);
        }
        return [];
    }
    contieneValidazioniCorrelate(){
        return Object.keys(this.variazioneDiValidazione.variazioniCorrelate).some(k => this.variazioneDiValidazione.variazioniCorrelate[k]._accettata);
    }
    private applicaModifica(variazione: VariazioneRigaDistinta) {
        if(this.riga.quantitaPerTaglia) {
            // this.riga.quantitaPerTaglia.forEach(qtaTaglia => {
            //     let index = +qtaTaglia.indice - 1;
            //     this.variazioneDiValidazione.quantitaPerTagliaComunicate.splice(index, 1, variazione.quantitaPerTagliaComunicate[index]);
            // });
            for (let index = 0; index < this.riga.quantitaPerTaglia.length; index++) {
                this.variazioneDiValidazione.quantitaPerTagliaComunicate.splice(index, 1, variazione.quantitaPerTagliaComunicate[+this.riga.quantitaPerTaglia[index].indice-1]);
            }
        }        
    }
    private esistonoVariazioniDaMostrare(){
        let ret = false;
        if(this.riga.variazioneGenerataDaValidazione){
           ret = this.riga.righeCorrelate.some(r => !r.contieneVariazioniDaValidare);
        } else{
           ret = this.riga.righeCorrelate.some(r => r.contieneVariazioniDaValidare);
        }
        return ret && this.riga.righeCorrelate.some(r => !r.inAttesaDiSincronizzazione);
    }
    private applicaCancellazione() {
        this.variazioneDiValidazione.statoValidazione = StatoVariazioneRigaDistinta.RigaEliminataDaBC;
    }
    private annullaCancellazione() {
        this.variazioneDiValidazione.statoValidazione = StatoVariazioneRigaDistinta.RigaEliminataDalFornitore;
        this.variazioneDiValidazione._accettata = false;
    }

    private accettaVariazione() {            
        Object.assign(this.backupVariazione , this.variazioneDiValidazione);           
        this.variazioneDiValidazione._accettata = true;
        if(this.variazioneDiValidazione.statoValidazione == StatoVariazioneRigaDistinta.RigaModificataDalFornitore ||
            this.variazioneDiValidazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore){
            this.variazioneDiValidazione.statoValidazione = StatoVariazioneRigaDistinta.RigaModificataDaBC;
        }
        
    }
    private annullaVariazione() {
        Object.assign(this.variazioneDiValidazione, this.backupVariazione); 
    }

    private contieneModificheCorrelate(v: VariazioneDaComunicare): boolean {
        return v.variazioniCorrelate.some((correlata: VariazioneDaComunicare) => {
        return correlata.tipoVariazione == TipoVariazione.NUOVA
            || (v.tipoVariazione != TipoVariazione.NUOVA && this.isVariazioneModified(correlata))
            || (v.tipoVariazione != TipoVariazione.NUOVA && this.isVariazioneDeleted(correlata));
        });
    }
    private isVariazioneModified(variazione: VariazioneDaComunicare): boolean {
        return variazione.variazioneRigaDistintaQtaTaglia.some(
        (variazione: VariazioneDaComunicareQtaTaglia) =>
            variazione.qta != variazione.qtaModificata
        );
    }
    private undoVariazione(){
        
        //TODO gestire con chiamata a componente figlio?
        Object.keys(this.variazioneDiValidazione.backupDict).forEach(k => {
            this.$delete(this.variazioneDiValidazione.variazioniCorrelate, k);  
            this.$set(this.variazioneDiValidazione.variazioniCorrelate, k, this.variazioneDiValidazione.backupDict[k]);   
            this.$delete(this.variazioneDiValidazione.backupDict, k);
        });

        if(this.backupVariazione.hasOwnProperty('indice')) 
            Object.assign(this.variazioneDiValidazione, this.backupVariazione); 
        this.riga.variazioneGenerataDaValidazione = false;
        this.riga.contieneVariazioniDaValidare = false;
    }
    private isVariazioneDeleted(variazione: VariazioneDaComunicare): boolean {
        return variazione.tipoVariazione == TipoVariazione.ELIMINATA;
    }
}
